import { Api } from './api';

export const dashboardCount = <T>(): Promise<T> => {
  return Api().get(`/reports/dashboard/counts`);
};

export const dailyDeliveryStats = <T>(query: string): Promise<T> => {
  return Api().get(`/reports/statistics${query}`);
};
